import { render } from "./ProjectShortlist.vue?vue&type=template&id=2a55be97"
import script from "./ProjectShortlist.vue?vue&type=script&lang=js"
export * from "./ProjectShortlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__